import { createContext } from 'react';

const Table3DContext = createContext(null);

export default Table3DContext;
